import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { SliderPanel } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBadgeCheck, faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import {
  FLOW_TYPES,
  ROUTES,
  getPathWithParam,
  usCurrency,
  usDateFormat,
} from "../../utils";

const ActiveLoansTile = (props) => {
  const {
    loanId,
    status,
    type,
    repaidAmount,
    amount,
    outstandingBalance,
    dateOfRequest,
    censusId,
    nextRepaymentDate,
    loanIdentifier,
  } = props;

  const progression = Math.round((repaidAmount / amount) * 100);
  const history = useHistory();

  return (
    <div
      className="d-flex align-items-baseline active-loan-tile w-100 cursor-pointer"
      onClick={() =>
        history.push(
          getPathWithParam({
            path: ROUTES.LOAN_SUMMARY,
            pathParam: [FLOW_TYPES.EDIT, censusId, loanId],
          })
        )
      }
    >
      <div className="loan-border-right pr-3 w-35">
        <div className="d-flex justify-content-between align-items-baseline">
          <span className="ft-14 fw-500">{type}</span>
          <span className="ft-12 fw-400 m-0 p-0 pl-1 active-status loan-border-left">
            <FontAwesomeIcon
              icon={faBadgeCheck}
              className="ft-12 mr-1 active-status"
            />
            {status}
          </span>
        </div>
        <div className="mt-1 mb-1">
          <div className="loan-progress-bar">
            <ProgressBar now={progression} />
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <span className="ft-12 card-text-color">
            {usDateFormat(dateOfRequest)}
          </span>
          <span className="ft-12 card-text-color">{progression}% paid</span>
        </div>
      </div>
      <div className="d-flex pl-3 w-65">
        <div className="w-20">
          <span className="ft-12 card-text-color mb-1">Loan Id</span>
          <p className="ft-12 fw-500 mb-1">{loanIdentifier ?? "-"}</p>
        </div>
        <div className="w-20">
          <span className="ft-12 card-text-color mb-1">Loan Amount</span>
          <p className="ft-12 fw-500 mb-1">{usCurrency(amount)}</p>
        </div>
        <div className="w-30">
          <span className="ft-12 card-text-color mb-1">
            Outstanding Balance
          </span>
          <p className="ft-12 fw-500 mb-1">{usCurrency(outstandingBalance)}</p>
        </div>
        <div className="w-30">
          <span className="ft-12 card-text-color mb-1">
            Next Repayment Date
          </span>
          <p className="ft-12 fw-500 mb-1">{usDateFormat(nextRepaymentDate)}</p>
        </div>
      </div>
    </div>
  );
};

export default ActiveLoansTile;
